import styled from 'styled-components';

export const Wrapper = styled.div`
    width:${props => props.inModal ? '100%' : '100vw'};
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    position:absolute;
    left:0;
    top:0;
    z-index:2000;
    & *{
        display: flex;
        justify-content: center;
        z-index: 1;
    }
`;